import React from 'react'
import Footer from './Footer';
import Hero from './lasoñada/Hero';
import Section2 from './lasoñada/Section2';
import Section1 from './lasoñada/Section1';
import Section3 from './lasoñada/Section3';
import Section4 from './lasoñada/Section4';
import Section5 from './lasoñada/Section5';

const Lasoñada = () => {
  return (
    <>  
        <Hero />
        <Section2 /> 
        <Section1 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Footer />
    </>
  )
}

export default Lasoñada